
import { Link } from 'react-router-dom';

import { faArrowDownUpLock, faHouseLaptop } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from './InfoIcon';

export default function NotAuthorized() {
  return (

    <div className='rso-pages notauthorized-container bg-warning m-0' >
      <InfoIcon icon={faArrowDownUpLock} className='mb-5' style={{ fontSize: 200 }} title='403 Not Authorized' withBubble={true} />

      <h1 style={{fontWeight:'bold',fontSize:100}} className='mb-2' >401</h1>
      <p style={{fontSize:20}} >
        You have not Access to this page
      </p>
          
      <Link to='/' className="btn btn-secondary bgnt" ><InfoIcon icon={faHouseLaptop} size='xl' />Dashboard</Link>

    </div>


  );
}

